import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-common-delete-dialog',
    templateUrl: './common-delete-dialog.component.html',
    styleUrls: ['./common-delete-dialog.component.scss'],
    standalone: false
})

export class CommonDeleteDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<CommonDeleteDialogComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: { target: string, deleteNames: string[] }) { }

    delete() {
        this.dialogRef.close(true);
    }
}
